import { render, staticRenderFns } from "./newBuildSite.vue?vue&type=template&id=bb1f5efa&scoped=true&"
import script from "./newBuildSite.vue?vue&type=script&lang=js&"
export * from "./newBuildSite.vue?vue&type=script&lang=js&"
import style0 from "./newBuildSite.vue?vue&type=style&index=0&id=bb1f5efa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1f5efa",
  null
  
)

export default component.exports